
export default {
  type: null,
  id: null,
  organizationUsers: []
}
